export default __webpack_public_path__ + "static/media/tree.d33a7599.svg";